<div class="pl-slider w-full pr-6">
  <mat-slider
    class="!w-full"
    [ngClass]="{
      'progress-bar-height-small': progressBarHeight === ProgressBarHeight.small,
      'progress-bar-height-large': progressBarHeight === ProgressBarHeight.large,
      'handle-color-orange': handleColor === SliderColor.orange,
      'handle-color-gray': handleColor === SliderColor.gray,
      'inactive-track-color-gray': inactiveTrackColor === SliderColor.gray,
      'inactive-track-color-orange': inactiveTrackColor === SliderColor.orange
    }"
    [disabled]="isDisabled"
    [max]="max"
    [min]="min"
    [step]="step"
    [discrete]="false"
    [showTickMarks]="showTicks"
  >
    <input matSliderThumb [(ngModel)]="value" (ngModelChange)="onSliderChange()" />
  </mat-slider>
</div>
